<template>
       <div>
           <!-- <mheader></mheader> -->
             <div style="width:1300px;margin:0 auto" id="v-content" :style="{minHeight:Height+'px'}">
                                <div class="sou_container" v-if="tableList.length==0">
                                      <div class="row">
                                            <span class="font_sou">药品名称:</span>
                                            <span>
                                                <input type="text" class="ml-lg-3 form-control input_sou" placeholder="药品名称" v-model="searchKey">
                                            </span>
                                            <router-link to="/plan/search">
                                                 <button class="btn btn-primary ml-lg-3 button_sou" @click="change()">搜索一下</button>
                                            </router-link>
                                            
                                      </div>
                                </div>
                   <!-- <table class="table table-striped table-hover">
                       <thead>
                            <tr>
                            <th>
                            <span class="d-block float-left mt-2">
                               供应商
                            </span>
                                <button class="float-right btn btn-primary font_btn">
                                   查询
                                </button>
                            </th>
                            <th>
                                <span class="d-block float-left mt-2">
                                     药品
                                </span>
                                  <button class="float-right btn btn-primary font_btn">
                                       查询
                                  </button>
                            </th>
                            <th>
                                <span class="d-block float-left mb-2">
                                    进价
                                </span>
                            </th>
                            <th>
                                <span class="d-block float-left mt-2">
                                     批量价
                                </span>
                                 <button class="float-right btn btn-primary font_btn">
                                      查询
                                 </button>
                            </th>
                            <th>
                                  <span class="d-block float-left mb-2">
                                     采购数量    
                                  </span>  
                            </th>
                            </tr>
                       </thead>
                       <tbody>
                         <tr>
                             <td>1</td>
                             <td>1</td>
                             <td>1</td>
                             <td>1</td>
                             <td>1</td>
                        </tr>
                        <tr>
                              <td>2</td>
                              <td>2</td>
                              <td>2</td>
                              <td>2</td>
                              <td>2</td>
                        </tr>
                       </tbody>   
                   </table> -->
                   <!-- <div v-if="tableList.length>0">
                    <div class="row ml-2 mt-5">
                     <div class="col-lg-6">
                               <div class="row">
                                      <div class="col-lg-3">
                                           <span class="d-block float-left font">
                                             供应商
                                           </span>
                                            <button class="float-right btn btn-primary font_btn" id="btn_add">
                                            查询
                                            </button>
                                      </div>
                                      <div class="col-lg-3">
                                           <span class="d-block float-left font">
                                             药品
                                           </span>
                                            <button class="float-right btn btn-primary font_btn" id="btn_yao">
                                             查询
                                            </button>
                                      </div>
                               </div>

                       </div>
                        <div class="col-lg-6">
                                <div class="row">
                                        <div class="col-lg-7">
                            <div class="row">
                                <div class="col-lg-6">
                                   <div class="row">
                                      <div class="col-lg-6 P-0">
                                          <div class="row ml-lg-1 p-0 font">
                                              查询日期:
                                          </div>
                                      </div>
                                      <div class="col-lg-6 p-0">                                             
                                              <date @changeDate="changeDate1($event)"/>                                         
                                      </div>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="row">
                                      <div class="col-lg-6 p-0 text-center font">
                                             到:
                                      </div>
                                      <div class="col-lg-6 p-0">
                                          <date class="picker2"  @changeDate="changeDate2($event)"/>
                                      </div>
                                  </div>
                              </div>
                          </div>  
                       </div>
                       <div class="col-lg-5">
                           <div class="row ml-lg-2 ">
                                 <button class=" btn btn-info font_btn ml-lg-2 w-25" @click="Search()">查询</button>
                                 <button class="btn btn-success font_btn ml-lg-2" id="btn_chuang">创建计划</button>
                           </div>
                       </div>        
                      </div>
                  </div>
                </div>  
                         <table class="table table-striped table-hover">
                                         <thead>
                                             <tr style="white-space: nowrap;">
                                                  <th>订单号</th>
                                                  <th>仓库号</th>
                                                  <th>供应商编号</th>
                                                  <th>供应商</th>
                                                  <th>数量</th>
                                                  <th>进阶</th>
                                                  <th>物价</th>
                                                  <th>创建时间</th>
                                                  <th>创建人</th>
                                                  <th>入库通知打印时间</th>
                                                  <th>入库通知打印人</th>
                                                  <th>品种编号</th>
                                                  <th>品名</th>
                                                  <th>生产厂家</th>
                                                  <th>上市许可持有人</th>
                                                  <th>规格</th>
                                                  <th>产地</th>
                                                  <th>包装</th>
                                                  <th>剂型或类型</th>
                                                  <th>单位</th>
                                                  <th>批准文号</th>
                                                  <th>批号</th>
                                                  <th>状态</th>
                                             </tr>
                                         </thead>
                                         <tbody>
                                              <tr>
                                                  <td>{{Num}}</td>
                                                  <td>{{StoreNo}}</td>
                                                  <td>{{SupplierNum}}</td>
                                                  <td>{{SupplierName}}</td>
                                                  <td>{{Counts}}</td>
                                                  <td>{{PurchPrice}}</td>
                                                  <td>{{WholePrice}}</td>
                                                  <td>{{CreateDate}}</td>
                                                  <td>{{Creater}}</td>
                                                  <td>{{NoticeDate}}</td>
                                                  <td>{{Noticer}}</td>
                                                  <td>{{DrugName}}</td>
                                                  <td>{{Factroy}}</td>
                                                  <td>{{DrugOwner}}</td>
                                                  <td>{{Specification}}</td>
                                                  <td>{{ProdAddress}}</td>
                                                  <td>{{Pack}}</td>
                                                  <td>{{DrugType}}</td>
                                                  <td>{{DrugUnit}}</td>
                                                  <td>{{ApprovalNum}}</td>
                                                  <td>{{BatchNum}}</td>
                                                  <td>{{States}}</td>
                                                  <td>
                                                       <button class="button_xuanze btn-success btn font_btn">
                                                            <span style="white-space:nowrap">
                                                                 可选择
                                                            </span>
                                                       </button>
                                                  </td>
                                              </tr>
                                         </tbody>
                                     </table>

                                         <div class="modal fade " id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="myModalLabel">查询</h4>
                                </div>
                                <div class="modal-body">
                                     <div class="card">
                                          <div class="card-header">
                                               <div class="font">
                                                   查询条件
                                               </div>
                                          </div>
                                          <div class="card-body">
                                               <div class="form-group d-flex">
                                                    <input type="text" class="form-control w-25" placeholder="供应商名称">
                                                    <button class="ml-lg-2 btn btn-primary">
                                                        搜索
                                                    </button>
                                               </div>
                                          </div>
                                     </div>
                               </div>
                            <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span aria-hidden="true"></span>关闭</button>
                                    <button type="button" id="btn_submit" class="btn btn-primary" data-dismiss="modal"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span>搜索</button>
                               </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade " id="myModal_yao" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="yaoping">查询</h4>
                                </div>
                                <div class="modal-body">
                                     <div class="card">
                                          <div class="card-header">
                                               <div class="font">
                                                   查询条件
                                               </div>
                                          </div>
                                          <div class="card-body">
                                               <div class="form-group d-flex">
                                                    <input type="text" class="form-control w-25" placeholder="供应商名称">
                                                    <input type="text" class="form-control w-25 ml-lg-2" placeholder="产地名称">
                                                    <input type="text" class="form-control w-25 ml-lg-2" placeholder="规格">
                                                    <button class="ml-lg-2 btn btn-primary">
                                                        搜索
                                                    </button>
                                               </div>
                                          </div>
                                     </div>
                               </div>
                            <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span aria-hidden="true"></span>关闭</button>
                                    <button type="button" id="btn_submit" class="btn btn-primary" data-dismiss="modal"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span>搜索</button>
                               </div>
                            </div>
                        </div>
                    </div>
                        <div class="modal fade" id="myModal_chuang" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="xingZeng"></h4>
                                </div>
                                <div class="modal-body font">
                                    <div class="form-group">
                                        <label for="txt_departmentname">供应商编号</label>
                                        <input type="text" name="txt_departmentname" class="form-control" id="txt_departmentname" placeholder="供应商编号">
                                    </div>
                                    <div class="form-group">
                                    <label for="txt_parentdepartment">药品编号</label>
                                        <input type="text" name="txt_parentdepartment" class="form-control" id="txt_parentdepartment" placeholder="药品编号">
                                    </div>
                                    <div class="form-group">
                                        <label for="txt_departmentlevel">业务员编号</label>
                                        <input type="text" name="txt_departmentlevel" class="form-control" id="txt_departmentlevel" placeholder="业务员编号">
                                    </div>
                                    <div class="form-group">
                                        <label for="txt_statu">创建人</label>
                                        <input type="text" name="txt_statu" class="form-control" id="txt_statu" placeholder="创建人">
                                    </div>
                                    <div class="form-group">
                                        <label for="txt_statu">进阶</label>
                                        <input type="text" name="txt_statu" class="form-control" id="txt_statu" placeholder="进阶">
                                    </div>
                                    <div class="form-group">
                                        <label for="txt_statu">批量价</label>
                                        <input type="text" name="txt_statu" class="form-control" id="txt_statu" placeholder="批量价">
                                    </div>
                                    <div class="form-group">
                                        <label for="txt_statu">采购数量</label>
                                        <input type="text" name="txt_statu" class="form-control" id="txt_statu" placeholder="采购数量">
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span>关闭</button>
                                    <button type="button" id="btn_submit" class="btn btn-primary" data-dismiss="modal"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span>创建</button>
                                </div>
                            </div>
                        </div>
                    </div>
                                      

                   </div> -->
                      
                
    </div>
</div>
</template>
<script>
import mheader from '../components/Header.vue'
import date from '../components/Date.vue'
export default {
      data(){
          return {
               Height:0,
              tableList:[],
              searchKey1:''
          }
      },
      components:{
          mheader,
          date,
      },
      methods:{
          getData:async function(){
               const {data:res} = await this.$http.post('Dls/getFun',
               {
               action: 'SupplierDrug',
                obj: JSON.stringify({
                pageIndex:1,
                searchKey1:"阿莫西林"
           
          })    
        }
               )
            //    console.log(res)
          },
        change(){
            
            
        }
      },
      mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
      created(){
         this.getData()
      }
}
</script>
<style scoped>
    .hei{
        height:1.5rem;
    }
     .font_btn{
         font-size:10px!important;
     }
     .jz_title{
          vertical-align: middle;
     }
     .sou_container{
         position:absolute;
         flex-wrap: wrap;
         top:35%;
         left:50%;
         transform: translateX(-50%) translateY(-50%);
     }
   .input_sou{
       width:300px;
       height:35px;
       font-size:20px;
   }
   .font_sou{
       font-size:20px;
   }
   .button_sou{
      height:35px;
   }
   .font{
    font-size:15px;
  }
  .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
 
</style>



// WEBPACK FOOTER //
// src/pages/NewPlan.vue